let cart_drawer_element = document.body;
let cd_config = {
    subtree: true,
    attributeOldValue: true
}
let handle_cart_drawer_cb  = async (mutationList) => {
    for (const mutation of mutationList) { 
    

       if(mutation.target.hasAttribute("data-cart-open") && mutation.target.getAttribute("data-cart-open")== "true") {
        window.convert_cart = "open";
       
       }
    }
    


  



    
}
let cart_drawer_observer = new MutationObserver(handle_cart_drawer_cb);
cart_drawer_observer.observe(cart_drawer_element, cd_config);